/* eslint-disable max-len */
import { gql } from "graphql-tag";

export const linkAppPrefillQuery = gql`
  query LinkAppPrefill($linkCode: String!) {
    linkAppPrefill(linkCode: $linkCode) {
      firstName
      lastName
    }
  }
`;

export const linkAppSubmissionMutation = gql`
  mutation LinkApp($firstName: String!, $lastName: String!, $phone: String!, $email: String!, $password: String!, $linkCode: String!) {
    linkApp(firstName: $firstName, lastName: $lastName, phone: $phone, email: $email, password: $password, linkCode: $linkCode) {
      success
    }
  }
`;
